import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const FocusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
  padding: 24px;
  background-color: ${Tokens.ColorBackground};
  border-radius: 12px;
`

export const FocusTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`

export const FocusItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FocusItemTitle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const FocusCheckDot = styled.span<{ $filled: boolean; $required: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 999px;
  border: 2px solid
    ${({ $filled, $required }) =>
      $filled ? Tokens.ColorUIPrimaryDim
      : $required ? Tokens.ColorUIDangerDim
      : '#9ca3af'};
  box-shadow: 0 0 4px
    ${({ $filled, $required }) =>
      $filled ? Tokens.ColorUIPrimaryDim
      : $required ? Tokens.ColorUIDangerDim
      : '#9ca3af'};
  background-color: ${({ $filled, $required }) =>
    $filled ? Tokens.ColorUIPrimary
    : $required ? Tokens.ColorUIDanger
    : '#d1d5db'};
  display: inline-block;
  flex-shrink: 0;
`
